export default "__VITE_ASSET__5c759ee4__"